import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { getDisciplineGroups } from '../../../api/services/disciplineGroupService';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';
import DisciplineGroup from '../../../api/models/disciplineGroup';

type ViewState = {
  message?: string;
};

const ViewDisciplineGroups = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Group Name',
        accessor: (d: any) => d.name ?? '',
        width: '90%'
      },
      {
        Header: 'Active',
        accessor: (d: any) => d.isVisible ? 'Active' : 'Inactive',
        width: '10%'
      },
      {
        accessor: 'disciplineGroupId',
        disableSortBy: true,
        Cell: () => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon className="w-5 h-5 cursor-pointer" aria-hidden="true" />
              </span>
            </div>
          );
        },
        width: 50,
        className: "hidden sm:table-cell"
      },
    ],
    []
  );

  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const [disciplineGroups, setDisciplineGroups] = useState<DisciplineGroup[]>([]);

  const { error, isPending } = useAsync({
    promiseFn: getDisciplineGroups,
    onResolve: (r) => {
      setDisciplineGroups(r.data.disciplineGroups);
    },
  });

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={isPending}>
      <Fragment>
        {state?.message && <Notification message={state?.message} />}
        <div className='mb-4 mt-4 text-right'>
          <Link className='btn ml-4' to='/admin/disciplines/groups/new'>
            Add Group
          </Link>
        </div>

        <DataTable
          columns={columns}
          data={disciplineGroups}
          showPagination={true}
          getRowProps={(row: any) => ({
            onClick: () => history.push(`/admin/disciplines/groups/${row.values.disciplineGroupId}`),
            className: "cursor-pointer hover:bg-gray-100",
          })}

        />
      </Fragment>
    </Layout>
  );
};

export default ViewDisciplineGroups;
